export default function initFilterDisplay() {
  const filterDisplays = document.querySelectorAll(".filter-display");

  filterDisplays.forEach((filterDisplay) => {
    const projectContainer = filterDisplay.closest(".project-container");
    const textSpan = filterDisplay.querySelector(".filter-display-text");

    if (!projectContainer || !textSpan) return;

    filterDisplay.addEventListener("click", () => {
      const isMapView = filterDisplay.classList.toggle("is-map-view");
      projectContainer.classList.toggle("is-map-view", isMapView);

      // Update text based on current state
      if (isMapView) {
        textSpan.textContent = textSpan.dataset.grid;
      } else {
        textSpan.textContent = textSpan.dataset.map;
      }
    });
  });
}
